<template>
  <div
    class="flex items-center justify-center overflow-hidden ring-1 ring-black/10"
    :class="{
      'size-3 rounded-sm': size === 'sm',
      'size-4 rounded-sm': size === 'md',
      'size-6 rounded-sm': size === 'lg',
      'size-8 rounded-md': size === 'xl',
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: "IconWrapper",
  });

  withDefaults(
    defineProps<{
      size?: "sm" | "md" | "lg" | "xl";
    }>(),
    {
      size: "md",
    }
  );
</script>
